var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#CE0505"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8166 6.09671C10.7907 5.41994 11.3324 4.85718 12.0097 4.85718C12.6879 4.85718 13.2299 5.42153 13.2026 6.09924L12.8688 14.3622C12.85 14.8279 12.467 15.1958 12.0009 15.1958C11.534 15.1958 11.1507 14.8268 11.1328 14.3603L10.8166 6.09671ZM12.022 20.0953C11.6117 20.0953 11.2674 19.9658 10.989 19.7068C10.7106 19.4334 10.5714 19.1024 10.5714 18.7139C10.5714 18.3254 10.7106 18.0017 10.989 17.7427C11.2674 17.4693 11.6117 17.3326 12.022 17.3326C12.4322 17.3326 12.7692 17.4693 13.0329 17.7427C13.2967 18.0017 13.4286 18.3254 13.4286 18.7139C13.4286 19.1024 13.2894 19.4334 13.011 19.7068C12.7472 19.9658 12.4176 20.0953 12.022 20.0953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.8163ed2ee313ed3d9d3e17f6bfbe1a5d.svg";
export { ForwardRef as ReactComponent };